import React from 'react'
import { connect } from 'react-redux'

export const CMSMeetingInfo = (props) => {
  return (
    <div>CMSMeetingInfo</div>
  )
}

const mapStateToProps = (state) => ({})

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(CMSMeetingInfo)